<template>
  <div>
    <div class="box is-boxed has-background-white-bis" style="max-height: 400px; overflow: auto;">
      <div v-if="!isEmpty(sections)">
        <div class="box section-box is-boxed" v-for="(section, index) in sections" :key="index" style="margin-bottom: 10px; padding: 11px;">
          <nuxt-link :to="{path: group.type == 'ACADEMIC' ? `/panel/classes/${group.id}/sections/${section.id}` : `/panel/groups/${group.id}/sections/${section.id}`}">
            <div class="columns is-vcentered">
              <div class="column">
                <p class="subtitle has-text-grey is-6" style="margin-bottom: 0; font-size: 14px;">Sesi ke {{ section.meet }}</p>
                <p class="title has-text-primary is-6" style="margin: 0;">{{ section.topic || '-' }}</p>
                <p class="subtitle has-text-grey is-6" style="margin: 0; font-size: 12px;">{{ section.materials.length || 0 }} Materi</p>
              </div>
            </div>
          </nuxt-link>

          <br v-if="show_materials">
          <div class="box" v-if="show_materials">
            <p v-if="!isEmpty(section.materials)"><strong>Materi Pembelajaran</strong></p>

            <ul v-if="!isEmpty(section.materials)">
              <li v-for="(m, index) in section.materials" :key="index">
                <nuxt-link :to="{path: group.type == 'ACADEMIC' ? `/panel/classes/${group.id}/sections/${section.id}/${m.id}` : `/panel/groups/${group.id}/sections/${section.id}/${m.id}`}" class="has-text-primary">
                  <span class="icon"><i class="fas fa-angle-double-right"></i></span><span>{{ m.title }}</span>
                </nuxt-link>
              </li>
            </ul>

            <p v-if="isEmpty(section.materials)" class="has-text-grey">Materi tidak ditemukan</p>
          </div>
        </div>
      </div>

      <div v-else class="box"><p class="has-text-grey has-text-centered">Sesi tidak ditemukan.</p></div>
    </div>
  </div>
</template>

<script>
import { SECTION } from '~/consts';

export default {
  mounted() {
    this.getSections();
  },

  props: {
    group: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      sections: [],
      show_materials: false
    }
  },

  methods: {
    getSections() {
      const vm = this;

      this.$axios.post(SECTION.GET_ALL(this.group.id))
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            vm.sections = data.data
          }
        }).catch(() => {

        });
    },
  }
}
</script>

<style scoped lang="scss">
.section-box {
  padding: 15px;
  position: relative;

  .title {
    font-weight: 700;
  }
}
.section-columns {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}
.button-meet {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 50px;
  padding-right: 35px;
}
</style>
